export enum UploadFileTypeEnum {
  RATE = 'RATE',
  SURCHARGE = 'SURCHARGE',
  PROFILE_PIC = 'PROFILE_PIC',
  TERM = 'TERM',
  SCHEDULE = 'SCHEDULE',
  ATTACHMENT = 'ATTACHMENT',
}
